import { docEntityTypeMap } from "building-types/doc/docEntityTypes";
import type { DocEntityType } from "../doc/docEntityTypes";

export function isDocEntityType(type: string): type is DocEntityType {
  return !!docEntityTypeMap[type as DocEntityType];
}
